export default __webpack_public_path__ + "static/media/upArrowYellow.7d706228.svg";